import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../../../services/loading.service';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (loadingService.loading$ | async) {
      <div class="fixed inset-0 bg-black/50 z-[99999] flex items-center justify-center loading-container">
        <div class="bg-white rounded-lg p-6 flex flex-col items-center shadow-xl">
          <div class="loading loading-spinner loading-lg text-primary"></div>
          @if (loadingService.message$ | async; as message) {
            <p class="mt-4 mb-0 text-sm text-center" role="status">{{ message }}</p>
          }
        </div>
      </div>
    }
  `,
  styles: [`
    .loading-container {
      animation: fadeIn 0.15s ease-in-out;
    }
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
  `]
})
export class LoadingComponent {
  constructor(public readonly loadingService: LoadingService) {}
}
